import './styles.css';
import { App } from './ui/app';
import { WakeRenderer } from './ui/render';

const root = document.getElementById('app');
if (!root) throw new Error('#app non trovato');

new App(root, WakeRenderer);
